import { AbstractControl } from "@angular/forms";

//special custom validator
export function validateMsZehutControl(control: AbstractControl) {
        let value: string = String(control.value);
        let result = { invalid_ms_zehut: false };
        var first8 = null;
        var cifratBikoret = null;
        try 
        {
            if (value.length == 10)
                first8 = value.substring(0, 9);
            else {
                if (value.length == 9)
                    first8 = "0" + value.substring(0, 8);
                else
                    first8 = "00" + value.substring(0, 8);
            }
            cifratBikoret = value.substring(value.length - 1);
            var checkDigits = 0 * 1;
            var temp = 0;
            var i = 0;
    
            for (i = 1; i <= 9; i++) {
                temp = first8.charAt(i - 1);
                checkDigits = temp * 1 + checkDigits * 1;
                if ((i % 2) == 1) {
                    checkDigits = temp * 1 + checkDigits * 1;
                    if (temp > 4)
                        checkDigits = checkDigits * 1 - 9;
                }
            }
            checkDigits = (10 - checkDigits % 10) % 10;
            result.invalid_ms_zehut = (checkDigits * 1 != cifratBikoret * 1);
        }
        catch (e) { result.invalid_ms_zehut = true; }
        
        if (value == "0")
        {
            result.invalid_ms_zehut = true;
        }
         if(result.invalid_ms_zehut)
        {
            return result;
        }
    }